<!-- A school that has uploaded its own HTML for this page gets that instead. Everything in
     #standardPage below is the built-in page, used whenever there is no custom file. -->
<div #hidewhenloading class="school-home hidewhenloading mx-auto text-sm px-md-5 mx-md-5"
     *ngIf="customPageHtml; else standardPage"
     [innerHTML]="customPageHtml"></div>

<ng-template #standardPage>
<div class="school-home mx-auto text-sm px-md-5 mx-md-5">
  <!-- Empty, but keep it: #step30 is an anchor for the guided tour ("School Card"),
       see toursteps in schoolhome.component.ts. Deleting it breaks that tour step. -->
  <div id="step30"  class="school-card-and-description-wrap d-flex flex-column flex-md-row align-items-start">
    
    
  </div>

  <section id="step41" class="mt-5" *ngIf="currentUserIsAdmin && displayFreePlanNotification">
    <div class="bg-white p-4 rounded shadow-sm-darker">
      You are on the free plan. You can change your plan <a routerLink="/account/schoolplan" class="text-link"><b>here</b></a>
    </div>
  </section>

  <section class="d-flex flex-column flex-md-row">
    <div class="col-md-6">
      <h1>{{this.schoolInfo?.schoolName}}</h1>
      <div class="flex-fill w-100">
        <div #descriptiondiv [innerHTML]="descriptionhtml" class="innerHTML-wrap overflow-hidden transition"
          [style.max-height]="descriptionIsExpanded ? descriptiondiv.scrollHeight + 'px' : '100px'"></div>
        <div class="border-t-border-line border-black mt-{{descriptionIsExpanded ? '4' : '0'}}"
          [style.display]="descriptiondiv.scrollHeight > 100 ? 'block' : 'none'">
          <button (click)="descriptionIsExpanded = !descriptionIsExpanded"
            class="school-description-height-toggle fa fa-angle-{{descriptionIsExpanded ? 'up' : 'down'}} bg-white rounded-circle border-0 shadow-sm-darker text-2xl text-reset d-flex mx-auto"
            title="Read {{descriptionIsExpanded ? 'Less' : 'More'}}"></button>
        </div>
      </div>
      <div class="d-flex flex-column flex-md-row justify-content-center align-items-md-start justify-content-md-start">
        <button routerLink="/site/courses" class="btn btn-primary m-0 my-2 p-1 col-md-6">Explore Courses</button>
        <button routerLink="/site/coursescalendar" class="btn btn-primary m-0 my-2 ml-md-3 p-1 col-md-6">Course Calender</button>
      </div>      
    </div>
    <div class="col-md-6">
      <img src="{{schoollogourl}}" alt="Banner image for {{schoolInfo.schoolName}}"
          class="w-100 bg-black-100 object-cover object-center">
      <!-- <div>
        <i class="fa fa-star text-warning" *ngFor="let i of [1,2,3]"></i>
        <i class="fa fa-star text-light" *ngFor="let i of [1,2]"></i>
        <span class="text-dark ms-2">{{ 3 }}/5</span>
        <div>School rating on Impata</div>
      </div> -->
    </div>
  </section>

  <div #contact 
    class="d-md-flex justify-content-around w-100 mt-5 p-2
      school-card rounded-md shadow-sm-darker overflow-hidden flex-shrink-0" 
    *ngIf="schoolInfo?.schoolEmail || schoolInfo?.schoolNumber">

    <div class="d-flex align-content-start">
      <i class="school-card__icon fa fa-envelope text-primary-darker mr-2" title="Email"></i>
      <a href="mailto:{{schoolInfo.schoolEmail}}" class="text-link">
        {{!schoolInfo.schoolEmail || schoolInfo.schoolEmail === '' ? '-' : schoolInfo.schoolEmail}}
      </a>
    </div>

    <div class="d-flex align-content-start my-2">
      <i class="school-card__icon fa fa-phone-alt text-primary-darker mr-2" title="Phone"></i>
      <a href="tel:{{schoolInfo.schoolNumber}}" class="text-link">
        {{!schoolInfo.schoolNumber || schoolInfo.schoolNumber === '' ? '-' : schoolInfo.schoolNumber}}
      </a>
    </div>
    
    <div class="d-flex align-content-start">
      <i class="school-card__icon fa fa-globe text-primary-darker mr-2" title="Url"></i>
      <a href="{{this.windowProtocol}}//{{schoolInfo.subdomain}}.{{baseUrl}}" class="text-link">
        {{this.windowProtocol}}//{{schoolInfo.subdomain}}.{{baseUrl}}
      </a>
    </div>
  </div>

  <div class="mt-5 fade-in-section">
    <h2 class="mt-5">Learn your way</h2>
    <p>We know that no two learners are the same. That's why {{schoolInfo?.schoolName}} offers multiple delivery formats to fit your
      schedule, learning style, and goals - all with the same high-caliber instruction and outcomes.</p>
  </div>
  
  <section class="mt-5 fade-in-section2">
    <div class="mt-3">
      <div class="feature-grid">
        <div class="text-start">
          <div class="mb-3 feature-icon d-flex justify-content-center" aria-hidden="true">
            <svg class="feature-icon-svg" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
              <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M 2.5 9 L 45.5 9"/>
                <path d="M 8.5 41.5 H 39.5"/>
                <path d="M 8.5 41.5 L 19.5 10"/>
                <path d="M 39.5 41.5 L 28.5 10"/>
                <path d="M 24 40 L 24 12" stroke-dasharray="3.2 4.2"/>
              </g>
            </svg>
          </div>
          <h3 class="feature-heading mb-3">Virtual Instructor-Led</h3>
          <p class="feature-text mb-0">
            Join live, interactive sessions from anywhere in the world. Ask questions in real time, participate in group exercises, and build connections with peers all from your own space.
          </p>
        </div>
        <div class="text-start">
          <div class="mb-3 feature-icon d-flex justify-content-center" aria-hidden="true">
            <svg class="feature-icon-svg" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
              <rect x="7" y="7" width="34" height="34" rx="8" ry="8" fill="none" stroke="currentColor" stroke-width="2"/>
              <circle cx="24" cy="24" r="9.5" fill="none" stroke="currentColor" stroke-width="2"/>
              <circle cx="19.35" cy="19.35" r="1.65" fill="currentColor" stroke="none"/>
              <circle cx="28.65" cy="19.35" r="1.65" fill="currentColor" stroke="none"/>
              <circle cx="19.35" cy="28.65" r="1.65" fill="currentColor" stroke="none"/>
              <circle cx="28.65" cy="28.65" r="1.65" fill="currentColor" stroke="none"/>
            </svg>
          </div>
          <h3 class="feature-heading mb-3">On-Demand Recordings</h3>
          <p class="feature-text mb-0">
            Access course recordings at your own pace, on your own schedule. Rewatch complex concepts, pause and practice, and revisit content whenever you need a refresher.
          </p>
        </div>
        <div class="text-start">
          <div class="mb-3 feature-icon d-flex justify-content-center" aria-hidden="true">
            <svg class="feature-icon-svg" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
              <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="24" cy="17" r="8"/>
                <path d="M10.5 41.5c0-7.6 5.8-13.8 13.5-13.8s13.5 6.2 13.5 13.8"/>
              </g>
            </svg>
          </div>
          <h3 class="feature-heading mb-3">In-Person Training</h3>
          <p class="feature-text mb-0">
            Experience the energy of face-to-face learning. Our in-person sessions combine instruction with hands-on workshops, role-play scenarios, and high-impact networking.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="mt-5">
    <h3 *ngIf="modulesURL" class="mb-3 text-center text-md-left">
      <span>Courses</span>
    </h3>
    <div *ngIf="currentUserIsAdmin && modulesComponent && !modulesComponent.hasModules()" class="bg-white p-4 rounded shadow-sm-darker">
      <button routerLink='/user/editmodule' class="btn">
        <i class="fa fa-plus"></i> Create Your First Course
      </button>
    </div>
    <app-modules *ngIf="modulesURL" [modulesURL]="modulesURL" [modulesPerPage]="6" [currentUserIsAdmin]="currentUserIsAdmin" #modulesComponent></app-modules>
  </section>

  <section id="step40" class="mt-5">
    <div *ngIf="(packagesComponent && packagesComponent.hasPackages()) || currentUserIsAdmin" style="position: relative;">
      <h3 class="mb-3 text-center text-md-left">
        <span>Packages </span>
        <span>
          <button *ngIf="currentUserIsAdmin" type="button" data-toggle="dropdown" aria-expanded="false" title="Packages Info" class="top-0 m-auto align-items-center px-3 bg-transparent border-0 text-body">
              <i class="fa fa-info-circle"></i>
          </button>
          <div class="info-popup dropdown-menu p-2">
            <p class="form-info-p">A package allows you to group courses together. When a student enrolls for a package, they get access to all the courses in that package
            </p>
          </div>
        </span>
    </h3>
      <div *ngIf="currentUserIsAdmin && packagesComponent && !packagesComponent.hasPackages()" class="bg-white p-4 rounded shadow-sm-darker">
        <button routerLink='/user/editpackage' class="btn">
          <i class="fa fa-plus"></i> Create Your First Package
        </button>
      </div>
    </div>
    <app-module-packages #packagesComponent [embeded]="true"></app-module-packages>
  </section>

  <section class="rounded-md shadow-sm-darker text-white p-5" 
    style="background-color: var(--primary-darker);"
    *ngIf="!useraccessservice.loggedIn()">
    <div class="d-md-flex justify-content-between align-items-center">
      <div>
        <h2 class="text-white">
          Ready to start learning today?
        </h2>
        <p class="text-light">
          Join thousands of students already building the skills they need to
          thrive. Get full access to all courses, certificates, and community
          support.
        </p>
      </div>

      <div>
        <a routerLink="/access/register" class="btn btn-sm mb-1">Create account</a>
        <a routerLink="/access/login" class="btn btn-sm">Sign in</a>
      </div>
    </div>
</section>

</div>
</ng-template>

<div class="modal fade" #enrolstudents id="enrolstudents" aria-hidden="true" aria-labelledby="enrolstudents" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Enrol Students</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p><a href="../../assets/templates/StudentEnrollTemplateBatched.xlsx" class="text-link text-xs"><i class="fa fa-info-circle"></i> Download Template</a></p>
        <form #uploadform="ngForm" (ngSubmit)="enrolstudent(files.files)" name="uploadform">
          <p class="text-center text-sm">{{enrolFileName || 'No File Selected'}}</p>
          <button (click)="files.click()" type="button" id="filesLabel" class="btn m-auto">Select File</button>
          <input #files (change)="enrolFileName = files.files[0]?.name" type="file" name="files" accept=".xls,.xlsx" aria-labelledby="filesLabel" id="classfile" class="sr-only" required>
          <div class="d-flex justify-content-around flex-wrap gap-1.5 mt-5">
            <button type="submit" class="btn m-0" [disabled]="files.files.length < 1">Upload</button>
            <button type="button" class="btn btn--warning m-0" (click)="closeEnrolModal()">Close</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>